import { UseTranslateResult } from "@tolgee/react";
import { FILE_FORMAT_ERROR } from "tools/file/createLogoUploadListener";
import { GridCellError } from "view/components/TasksList/components/Modals/ResponseModal/forms/GridForm/helpers";

type TranslateFn = UseTranslateResult["t"];

// The `message` produced here is rendered verbatim by `GridErrorMessage`, so it
// must already be localized — hooks can't run in this module, so the calling
// component threads its `t` in.
export const FileUploadError = {
  fileSizeExceeded: (
    fileName: string,
    fileSizeLimit: number,
    t: TranslateFn
  ) => ({
    message: t("common.tasks.grid.cell.file_size_exceeded", {
      fileName,
      fileSizeLimit,
    }),
    type: GridCellError.MaxFileSize,
  }),
  maxNumFilesExceeded: (maxNumOfFiles: number, t: TranslateFn) => ({
    message: t("common.tasks.grid.cell.max_files_error", { maxNumOfFiles }),
    type: GridCellError.MaxNumberFiles,
  }),
  invalidFileFormat: (acceptedExtensions: string[], t: TranslateFn) => ({
    message: FILE_FORMAT_ERROR(acceptedExtensions, undefined, t),
    type: GridCellError.InvalidFileFormat,
  }),
};
